import { WEB_PREFIX } from 'constants/common';

export const ABOUT_US_VIEW = `${WEB_PREFIX}about-us-view`;

export const ABOUT_US_TITLE_LABEL = `${ABOUT_US_VIEW}_title-label`;

export const ABOUT_US_CONTENT_ID = `${ABOUT_US_VIEW}_content`;
